import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from "./store"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import request from './api/config/request'
import currentDate from './assets/js/getdates'
import calendar from './assets/js/getCalendar'
import locale from 'element-plus/lib/locale/lang/zh-cn'

const app = createApp(App)
    if (window.location.href.includes("192.168")) {
        app.config.globalProperties.$baseImgUrl = "http://192.168.1.136:8091";
    } else {
        app.config.globalProperties.$baseImgUrl = "http://113.200.222.201:18081";
    }
    app.config.globalProperties.$request = request
    app.config.globalProperties.$currentDate = currentDate
    app.config.globalProperties.$calendar = calendar
    app.use(router)
    .use(store)
    .use({locale})
    .use(ElementPlus)

app.mount('#app')